export class ActionEvent {
    data: any;

    _defaultPrevented: boolean;

    constructor(data?: any) {
        this.data = data;
    }

    preventDefault(): void {
        this._defaultPrevented = true;
    }

    isDefaultPrevented(): boolean {
        return this._defaultPrevented;
    }
}
